import {useEffect, useRef} from 'react';
import {Action, tokens} from '@sail/ui';
import {WalletItem} from 'src/v2/components/wallet/WalletItem';
import type {PaymentOption} from 'src/v2/state/types';

interface Props {
  walletOptions: PaymentOption[];
  onWalletPress: (walletOption: PaymentOption) => void;
  focusedIndex?: number;
  onFocusChange?: (index: number) => void;
}

export const WalletGrid = ({
  walletOptions,
  onWalletPress,
  focusedIndex,
  onFocusChange,
}: Props) => {
  const itemRefs = useRef<(HTMLAnchorElement | null)[]>([]);

  useEffect(() => {
    // focusedIndex >= 0 means a grid item should be focused (not the search input)
    if (focusedIndex !== undefined && focusedIndex >= 0) {
      itemRefs.current[focusedIndex]?.focus();
    }
  }, [focusedIndex]);

  return (
    <>
      {walletOptions.map((walletOption, index) => (
        <Action
          ref={(el: HTMLAnchorElement | null) => {
            itemRefs.current[index] = el;
          }}
          key={
            walletOption.provider === 'WalletConnect' ||
            walletOption.provider === 'Exchange'
              ? walletOption.key
              : walletOption.provider
          }
          onPress={() => onWalletPress(walletOption)}
          css={{
            width: 'fill',
            borderRadius: 'small',
            ':hover': {
              backgroundColor: tokens.color.neutral[50].toString(),
            },
            ':focus-visible': {
              backgroundColor: tokens.color.neutral[50].toString(),
            },
            padding: '12px 4px 8px 4px',
          }}
          onFocus={() => onFocusChange?.(index)}
        >
          <WalletItem walletOption={walletOption} />
        </Action>
      ))}
    </>
  );
};
